import * as vegetationIndexApi from '@/api/vegetation_index/index';
import store from '@/store';
import * as mt from '@/store/vegetation-index/mutation-types';
import { VegetationIndexState } from '@/store/vegetation-index/types';


export async function cleanup() {
  await store.dispatch(`vegetationIndex/${mt.CLEANUP}`);
}

export async function fetchAllAveragesByAnalysisAndType(uuid :string, vegetationIndexType: string, 
  cropType: string = "SOY",harvestSeason: string = "SUMMER",) {
  // @ts-ignore
  const averageState = (store.state.vegetationIndex as VegetationIndexState).averageStatus.get(uuid);

  if (!averageState?.startsWith('fetching')) {
    await store.dispatch(`vegetationIndex/${mt.FETCHING_VEGETATION_INDEX_AVERAGE}`);
    try {
      const averages = (await vegetationIndexApi.findAllAveragesByAnalysisAndType(uuid, vegetationIndexType, cropType, harvestSeason)).data;
      await store.dispatch(`vegetationIndex/${mt.FETCH_VEGETATION_INDEX_AVERAGE}`,
        { uuid, vegetationIndexAverages: averages }
      );
    } catch (error) {
      await store.dispatch(`vegetationIndex/${mt.FETCH_FAILURE}`, uuid);
    }
  }
}

export async function fetchAllAveragesByAnalysisForCrotTypeNotConfirmed(uuid :string, vegetationIndexType: string,
  cropType: string = "SOY", harvestSeason: string = "SUMMER") {

  // @ts-ignore
  const averageState = (store.state.vegetationIndex as VegetationIndexState).averageStatusForCropTypeNotConfirmed.get(uuid);

  if (!averageState?.startsWith('fetching')) {
    await store.dispatch(`vegetationIndex/${mt.FETCHING_VEGETATION_INDEX_AVERAGE_FOR_CROP_TYPE_NOT_CONFIRMED}`);
    try {
      const averages = (await vegetationIndexApi.findAllAveragesByAnalysisForCropTypeNotConfirmed(uuid, vegetationIndexType, 
        cropType, harvestSeason)).data;
      await store.dispatch(`vegetationIndex/${mt.FETCH_VEGETATION_INDEX_AVERAGE_FOR_CROP_TYPE_NOT_CONFIRMED}`,
        { uuid, vegetationIndexAverages: averages }
      );
    } catch (error) {
      await store.dispatch(`vegetationIndex/${mt.FETCH_FAILURE_FOR_CROP_TYPE_NOT_CONFIRMED}`, uuid);
    }
  }
}

export async function fetchAllByCropAndType(cropUuid :string, vegetationIndexType: string) {
  // @ts-ignore
  const cropState = (store.state.vegetationIndex as VegetationIndexState).cropStatus.get(cropUuid);

  if (!cropState?.startsWith('fetching')) {
    store.dispatch(`vegetationIndex/${mt.FETCHING_VEGETATION_INDEX_CROP}`, cropUuid);
    
    try {
      const cropData = (await vegetationIndexApi.findAllByCropAndType(cropUuid, vegetationIndexType)).data;
      store.dispatch(`vegetationIndex/${mt.FETCH_VEGETATION_INDEX_CROP}`, { uuid: cropUuid, vegetationIndexCrop: cropData });
    } catch (err) {
      store.dispatch(`vegetationIndex/${mt.FETCH_CROP_FAILURE}`, cropUuid);
    }
  }
}
